module.exports = __webpack_public_path__ + "static/DSC_9445-52f98d665e40a228c83027fb41844a28.jpg";